import React, { useEffect, useState } from "react";

export default function OpenInAppBanner({ deeplink = "/" }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ua = (navigator.userAgent || "").toLowerCase();
    const isMobile = /iphone|ipad|ipod|android/.test(ua);

    // extra guards for native WebView
    const inCapacitor =
        typeof window !== "undefined" &&
        !!window.Capacitor &&
        (window.Capacitor.isNativePlatform?.() ||
        window.Capacitor.App ||
        window.Capacitor.Plugins?.App);

    const isInApp =
        inCapacitor || /satstacker/.test(ua) || window.navigator.standalone === true;

    const dismissed = localStorage.getItem("openInAppDismissed") === "1";
    if (isMobile && !isInApp && !dismissed) setShow(true);
    }, []);

  function openApp() {
    const ua = (navigator.userAgent || "").toLowerCase();
    const isAndroid = ua.includes("android");
    const isIOS = /iphone|ipad|ipod/.test(ua);

    // Deep link target inside your app
    const targetPath =
        typeof window !== "undefined"
        ? (deeplink || (location.pathname + location.search + location.hash))
        : "/";

    // Prefer Universal/App Links (https) so iOS/Android open the app if installed
    const universalLink = `https://www.satstacker.app/open?path=${encodeURIComponent(targetPath)}`;
    window.location.href = universalLink;

    // If the app doesn't open (page stays visible), fall back after a short delay
    setTimeout(() => {
        if (document.visibilityState === "hidden") return; // app opened

        if (isAndroid) {
        // Play Store listing
        window.location.href = "https://play.google.com/store/apps/details?id=com.satstacker.app";
        } else if (isIOS) {
        // App Store listing
        window.location.href = "https://apps.apple.com/app/id6748700654";
        } else {
        // Desktop fallback
        window.location.href = "https://www.satstacker.app";
        }
    }, 1200);
    }

  if (!show) return null;

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background: "#111827",
        color: "#fff",
        padding: "8px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
      }}
    >
      <span style={{ fontSize: 14 }}>
        Open this in the SatStacker app for a smoother flow.
      </span>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          onClick={openApp}
          style={{
            background: "#f97316",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "6px 10px",
          }}
        >
          Open app
        </button>
        <button
          onClick={() => {
            localStorage.setItem("openInAppDismissed", "1");
            setShow(false);
          }}
          style={{
            background: "transparent",
            color: "#9CA3AF",
            border: "1px solid #374151",
            borderRadius: 8,
            padding: "6px 10px",
          }}
        >
          Not now
        </button>
      </div>
    </div>
  );
}
